import DeleteShopPaymentRequestModelBase from '../_generated/modelBases/delete-shop-payment-request-model-base';

export default class DeleteShopPaymentRequestModel extends DeleteShopPaymentRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
